import React from 'react';

const CustomerDetailItemOne = ({ label, value }) => (
    <div className="border-t border-gray-100 px-4 py-0 sm:col-span-1 sm:px-0">
        <dt className="text-sm font-medium leading-6 text-gray-900">{label}</dt>
        <dd className="mt-0 text-sm leading-6 text-gray-700 sm:mt-0">{value || 'N/A'}</dd>
    </div>
);

export default CustomerDetailItemOne;
